export default function buildVersionRows({ versionInfo, identitySyncs }) {
  return (
    versionInfo.syncVersions
      .map(syncVersion => {
        const identitySync = identitySyncs.find(is => is.identity_sync.name === syncVersion.syncName);
        if (!identitySync) return null;
        return {
          analyticsFileIdentitySyncId: identitySync.id,
          buildVersion: syncVersion.buildVersion,
          settingsVersion: identitySync.settingsVersion ?? 1,
          shouldResyncOnSettingsChange: identitySync.enableResyncOnSettingsChange === true,
        };
      })
      // filter null values out
      .filter(Boolean)
  );
}
